// Brand primary, same as PlanManager.tsx. Kept here so every screen in the module
// draws its accent from one place.
export const BRAND_PRIMARY = "#4F16C2";

export const PRIMARY_BUTTON_STYLE = {
	backgroundColor: BRAND_PRIMARY,
	borderColor: BRAND_PRIMARY,
	color: "#ffffff",
} as const;
